/**
 * Exported strictly for testing purposes
 * @internal
 */
const redirectTo = (url: string) => {
  window.location.href = url;
};

/**
 * Exported strictly for testing purposes
 * @internal
 */
const getPathName = () => window.location.pathname;

export { redirectTo, getPathName };
